module.exports = __webpack_public_path__ + "media/images/ibu__social__logo__facebook-18c5ba8cd770e3404ef13c3d4c0d03fc.svg";